<script lang="ts">
  export let title: string;
  export let url: string;
</script>

<a href={url} class="learning-history__title-link">
  {title}
</a>
